import * as React from 'react';
import { useState } from 'react';
import { connect } from 'react-redux';

import SVG from 'react-inlinesvg';
import styles from './userInfoComponents.module.scss';
import { Field, Form } from 'react-final-form';

import { Base64 } from 'js-base64';
import { bindActionCreators, Dispatch } from 'redux';
import { get } from 'lodash';

import { useTranslation } from 'react-i18next';
import { loginActions } from '../../../../store/login/actions';
import { RootState } from '../../../../store';
import { tr } from '../../../../utils/translations/translator';
import show from '../../../../assets/icons/show.svg';
import { AppleButtonConnected } from '../../../Login/AppleButton';
import { userInfoMethods } from '../../stages/UserInfo';
import { StoreType } from '../../interfaces/store_types';
import appleIcon from '../../../../assets/icons/shop/apple.svg';
import fbIcon from '../../../../assets/icons/shop/facebook.svg';

interface DispatchProps {
  actions: {
    newLoginRequest: (a: string, b: string) => void;
    newFBLoginRequest: (s: string) => any;
  };
}

interface OwnProps {
  showSelect?: boolean;
  selectedMethod: userInfoMethods | undefined;
  setSelectedMethod: (method: userInfoMethods) => void;
  storeType: StoreType;
}
type LoginProps = OwnProps & DispatchProps;

export const ShopLogin: React.FC<LoginProps> = ({
  actions,
  selectedMethod,
  setSelectedMethod,
  showSelect = false,
  storeType,
}) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const isOpen = React.useMemo(
    () => (!showSelect ? true : selectedMethod === 'LOGIN' ? true : false),
    [selectedMethod],
  );

  const required = (value: string) => (value ? undefined : tr(t, 'required'));
  const onSubmit = (d: any) => {
    actions.newLoginRequest(Base64.toBase64(`${d.username}:${d.password}`), '');
  };
  const handleSelect = () => {
    setSelectedMethod('LOGIN');
  };

  return (
    <div className={styles.container} onClick={() => handleSelect()}>
      <p>{tr(t, 'already_have_account')}</p>
      {showSelect && (
        <div className={styles.selectBtn}>
          <button
            className={isOpen ? styles.selected : styles.unselected}
            onClick={() => handleSelect()}
            type="button"
          ></button>
        </div>
      )}
      {isOpen && (
        <Form
          onSubmit={onSubmit}
          //@ts-ignore
          render={({ handleSubmit, invalid }) => (
            <form onSubmit={handleSubmit}>
              <div>
                <Field name="username" component="input" validate={required}>
                  {({ input, meta }) => (
                    <>
                      <input
                        {...input}
                        type="text"
                        placeholder={tr(t, 'login_username')}
                      />
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </>
                  )}
                </Field>
              </div>
              <div>
                <Field name="password" component="input" validate={required}>
                  {({ input, meta }) => (
                    <div className={styles.passWrapper}>
                      <input
                        {...input}
                        type={showPassword ? 'text' : 'password'}
                        placeholder={tr(t, 'login_password')}
                      />
                      <button
                        className={
                          showPassword ? styles.active : styles.unactive
                        }
                        type="button"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        <SVG src={show} />
                      </button>
                      {meta.error && meta.touched && (
                        <span className={styles.error}>{meta.error}</span>
                      )}
                    </div>
                  )}
                </Field>
              </div>
              <label className={styles.loginLabel}>
                {tr(t, 'or-login-with')}
              </label>
              <div className={styles.loginBtnsWrapper}>
                <button
                  className={styles.fbLogin}
                  type={'button'}
                  onClick={() => {
                    // @ts-ignore
                    FB.login(
                      function (response: any) {
                        const fbToken = get(response, [
                          'authResponse',
                          'accessToken',
                        ]);
                        if (fbToken && fbToken.length > 0) {
                          actions.newFBLoginRequest(fbToken);
                        }
                      },
                      { scope: 'public_profile,email' },
                    );
                  }}
                >
                  <img src={fbIcon} />
                </button>
                <div className={styles.appleLogin}>
                  <AppleButtonConnected image={appleIcon} />
                </div>
              </div>
              <div className={styles.loginBtnWrapper} id={styles[storeType]}>
                <button disabled={invalid} type={'submit'} id={styles.loginBtn}>
                  {tr(t, 'proceed-to-payment')}
                </button>
              </div>
            </form>
          )}
        />
      )}
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  //   user: userSelector(state),
});
const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      newLoginRequest: loginActions.loginRequestAction,
      newFBLoginRequest: loginActions.fbLoginRequest,
    },
    dispatch,
  ),
});

export const ShopLoginConnected = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ShopLogin);
